/**
 * Product card component
 * 
 * @module product-card
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-card';

if(!customElements.get(customElements.component)) {

    class productCard extends HTMLElement {

        /**
         * Web component constructor
         * 
         * @constructor
         */
        constructor() {

            super();

            this.classList.add('product-card');

            this.dataset.ready = (typeof this.dataset.static != 'undefined') ? true : false;

            if (this.dataset.ready == 'false') {

                window.theme.product.loadProduct(this.dataset.handle, true).then(product => {
    
                    this.product = product;

                    this.render(product);
                });
            }
        }

        /**
         * Render component in the DOM
         * 
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {

            let html = this.template();

            // Image Aspect Ratio ------------------------------------------------------------------------------------
            let defaultAspectRatio = window.default_aspect_ratio;


            // Current Variant ------------------------------------------------------------------------------------
            let availableVariants = (product.variants).filter(variant => {
                if(variant.available) return variant;
            });

            let currentVariant = availableVariants.length ? availableVariants[0] : null;
            
            // Get first variant when we dont have any one available
            if(!currentVariant) {
                currentVariant = product.variants[0];
            }

            // Padding Top Image
            let paddingTop = (defaultAspectRatio / 1) * 100;
            html = html.replaceAll(/{{productImagePadding}}/g, paddingTop);


            // Product Image ------------------------------------------------------------------------------------
            let defaultWidth = 600;
            let defaultImgHeight = Math.floor(defaultWidth * defaultAspectRatio);
            let customSize = defaultWidth.toString() + 'x' + defaultImgHeight.toString();
            let extension = '';
            let productImage = '';

            if(product.featured_image){
                extension = /[^.]+$/.exec(product.featured_image);
                productImage = (product.featured_image).replace('.' + extension, '_' + customSize + '_crop_top.' + extension);
                html = html.replaceAll(/{{productImageUrl}}/g, productImage);
            }
            else{
                if(window.product_no_image){
                    extension = /[^.]+$/.exec(window.product_no_image);
                    productImage = (window.product_no_image).replace('.' + extension, '_crop_top.' + extension);
                    html = html.replaceAll(/{{productImageUrl}}/g, productImage);
                }
            }

            html = html.replaceAll(/{{productImageAltText}}/g, product.title);


            // Product Image Hover ------------------------------------------------------------------------------------
            if(product.images.length > 1) {

                let hoverHtml = `
                    <div class="opacity-0 absolute top-0 left-0 w-full transition-opacity group-hover:lg:opacity-100">
                        <div class="lazy-loading" style="padding-top:{{productImagePadding}}%;">
                            <img src="{{productHoverImageUrl}}" alt="{{productHoverImageAltText}}" loading="lazy" class="object-contain"/>
                        </div>
                    </div>
                `;

                hoverHtml = hoverHtml.replaceAll(/{{productImagePadding}}/g, paddingTop);

                let hoverProduct = product.images[1];
                extension = /[^.]+$/.exec(hoverProduct.src);
                productImage = (hoverProduct.src).replace('.' + extension, '_' + customSize + '_crop_top.' + extension);
                hoverHtml = hoverHtml.replaceAll(/{{productHoverImageUrl}}/g, productImage);
                hoverHtml = hoverHtml.replaceAll(/{{productHoverImageAltText}}/g, hoverProduct.alt);
                html = html.replaceAll(/{{productImageHover}}/g, hoverHtml);
            }
            else {
                html = html.replaceAll(/{{productImageHover}}/g, "");
            }


            // Product Vendor ------------------------------------------------------------------------------------
            html = html.replaceAll(/{{productVendor}}/g, product.vendor);

            
            /* Product Variants + Component Quickview ------------------------------------------------------------------------------------
            if(product.options.length) {

                let sizeOption = null;
                let variantsHtml = '';

                (product.options).forEach(option => {
                    if((option.name).toLowerCase() == "size") {
                        sizeOption = option;
                    }
                });

                if(sizeOption) {
                    let productVariants = product.variants;
                    let sizeOptionPosition = sizeOption.position;
                    let sizeWhereCondition = "option" + sizeOptionPosition.toString();
                    let availableVariantsSize = false;

                    (sizeOption.values).forEach(size_option => {
                        productVariants.forEach(variant => {
                            if((variant[sizeWhereCondition] == size_option) && (variant.available)) {
                                availableVariantsSize = true;
                            }
                        });

                        if(availableVariantsSize) {
                            variantsHtml += `
                                <component-quickview-trigger data-handle="{{productHandle}}" class="relative">
                                    <button  class="inline-block quick-view mr-2 hover:underline">
                                        ${size_option}
                                        <span class="quick-view__tooltip min-w-max bg-black text-white px-1 absolute font-secondary tracking-wider text-[10px] uppercase -top-8 -left-6">
                                            Quick View
                                        </span>
                                    </button>
                                </component-quickview-trigger>
                            `;
                        }
                        else {
                            variantsHtml += `
                                <component-quickview-trigger data-handle="{{productHandle}}" class="relative">
                                    <span  class="inline-block mr-2 text-disabled-dark cursor-default">
                                        ${size_option}
                                    </span>
                                </component-quickview-trigger>
                            `;
                        }

                        availableVariantsSize = false;
                    });

                    html = html.replaceAll(/{{productVariants}}/g, variantsHtml);
                }
            }
            */

            // Default Price ------------------------------------------------------------------------------------
            if(currentVariant) {
                let priceHtml = '';

                if(currentVariant.compare_at_price > currentVariant.price) {
                    priceHtml = `
                        <price-component data-handle="{{productHandle}}" class="product-price" data-product-single-update="price">
                            <span data-price class="product-price--current font-secondary text-sm leading-4">${window.theme.money.format(currentVariant.price)}</span>
                            <span data-compareatprice class="product-price--comparedtext-lg font-secondary line-through text-disabled-dark text-sm leading-4">${window.theme.money.format(currentVariant.compare_at_price)}</span>
                        </price-component>
                    `;
                }
                else {
                    priceHtml = `
                        <price-component data-handle="{{productHandle}}" class="product-price" data-product-single-update="price">
                            <span data-price class="product-price--current font-secondary text-sm leading-4">${window.theme.money.format(currentVariant.price)}</span>
                        </price-component>
                    `;
                }

                html = html.replaceAll(/{{productPrice}}/g, priceHtml);
            }

            // ReKeepIt Product Discount ------------------------------------------------------------------------------------
            let rki_product = product;
            let rki_variant_id = currentVariant.id;
            let rki_widget_id = product.id;
          
            // Detect if this product has an RKI discount
            let has_rki_discount = false;
            let rki_discount = null;

            (rki_product.tags).forEach(tag => {
                let tag_downcase = tag.toLowerCase();

                if(tag_downcase.includes("rki:")) {
                    has_rki_discount = true;
                    let pieces = tag.split(":");
                    let last = pieces[pieces.length - 1];
                    rki_discount = last * 1.00000000;
                }
            });

            // Showing only on product cards
            if(has_rki_discount) {

                let discountHtml = `
                    <div class="discount rki_badge_desc product-card absolute top-6 lg:top-0 right-0">
                        <p class="discount_text text-sm">
                            <span class="rki__logo__sm"></span>
                            ${rki_discount}%
                        </p>
                    </div>
                `;

                html = html.replaceAll(/{{productRekeepit}}/g, discountHtml);
            }


            // Product URL ------------------------------------------------------------------------------------
            html = html.replaceAll(/{{productUrl}}/g, `/products/${product.handle}`);
            

            // Default Properties ------------------------------------------------------------------------------------
            html = html.replaceAll(/{{productHandle}}/g, product.handle);
            html = html.replaceAll(/{{productTitle}}/g, product.title);
            html = html.replaceAll(/{{productId}}/g, product.id);

            this.innerHTML = html;
            this.dataset.ready = true;
        }

        /**
         * Get template
         * 
         * @returns {string} Component HTML template.
         */
        template() {

            if (window.templateProductCard) {

                return window.templateProductCard;

            } else {

                return `
                    <div>
                        <img src="{{imgUrl}}"/>
                        <a href="{{productUrl}}">{{productTitle}}</a>
                        <product-price data-handle="{{productHandle}}"></product-price>
                    </div>
                `;

            }
        }

    }

    customElements.define(customElements.component, productCard);
}

function initProductCardHoverVideos(root = document) {
    root.querySelectorAll('[data-product-card-hover-area]').forEach(card => {
        if (card.dataset.hoverVideoInit) return;
        card.dataset.hoverVideoInit = '1';

        const video = card.querySelector('[data-product-card-hover-video]');
        if (!video) return;

        card.addEventListener('mouseenter', () => video.play());
        card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; });
    });
}

document.addEventListener('DOMContentLoaded', () => initProductCardHoverVideos());

document.addEventListener('product-cards:loaded', (e) => {
    initProductCardHoverVideos(e.detail?.container || document);
});
